module.exports = __webpack_public_path__ + "img/Weapon_219.a8346ad4.png";